import { Injectable } from '@angular/core';
import { Product } from '../../model/product';
import { AngularFireDatabase } from 'angularfire2/database';
import { HttpClient, HttpHeaders , HttpParams} from '@angular/common/http';
import {address} from '../../../../environments/environment';

@Injectable()
export class LoginService {
  // private ROOT_URL = 'http://localhost:3333/api';
  private ROOT_URL = address.API_SERVER_ADDRESS;

  constructor(private db: AngularFireDatabase, private http: HttpClient) { }

  login(data){
      // console.log(data);
      return this.http.post('https://api.bhbazar.com/storeapi/store/adminuserlogin', data)
    // return this.http.post('http://localhost:8082/storeapi/store/adminuserlogin', data)
    
  }

  register(data){
    // console.log(data);
    
    return this.http.post('https://api.bhbazar.com/storeapi/store/adminuserregister', data)
    // return this.http.post('http://localhost:8082/storeapi/store/adminuserregister', data)
  }

}
